"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormPreviewAddress = void 0;
const country_1 = require("../enums/country");
const locales_1 = require("../enums/locales");
const FORM_PREVIEW_ADDRESSES = {
    [country_1.OrganizationCountry.UnitedStates]: { street: "123 Ocean Drive", city: "San Diego, CA" },
    [country_1.OrganizationCountry.Canada]: { street: "123 Queen Street West", city: "Toronto, ON" },
    [country_1.OrganizationCountry.GreatBritain]: { street: "123 Brick Lane", city: "London" },
    [country_1.OrganizationCountry.Australia]: { street: "123 Collins Street", city: "Melbourne VIC" },
    [country_1.OrganizationCountry.NewZealand]: { street: "123 Cuba Street", city: "Wellington" },
    [country_1.OrganizationCountry.Ireland]: { street: "123 Grafton Street", city: "Dublin" },
    [country_1.OrganizationCountry.Germany]: { street: "Torstraße 123", city: "10119 Berlin" },
};
const QUEBEC_FORM_PREVIEW_ADDRESS = { street: "123, rue Saint-Denis", city: "Montréal, QC" };
const getFormPreviewAddress = (country, locale) => {
    if (country === country_1.OrganizationCountry.Canada && locale === locales_1.Locales.FR) {
        return QUEBEC_FORM_PREVIEW_ADDRESS;
    }
    return FORM_PREVIEW_ADDRESSES[country ?? country_1.OrganizationCountry.UnitedStates];
};
exports.getFormPreviewAddress = getFormPreviewAddress;
